
































import { Component, Vue } from "vue-property-decorator";
import { apiService, AppConstants, Interfaces, Models } from "@/core/Export";
import AdditionListItem from "./AdditionListItem.vue";

import store from "@/store";
@Component({
  components: { AdditionListItem },
})
export default class AdditionList extends Vue {
  additionalItems = new Models.EmployeeAdditionalPortal();
  empAdditionTypeCodes = AppConstants.EmpAdditionTypeCodes;
  sourceCodeTypes = AppConstants.SourceCode;
  valueType = [];
  $q;

  constructor() {
    super();
  }
  created() {
    this.loadEntriesForDay();
    this.loadValueTypes();
  }
  loadEntriesForDay() {
    this.appEnv.isBusy = true;
    apiService
      .getEmployeeDayAdditionalPortalData(
        this.drawerParams.date,
        this.drawerParams.employeeId
      )
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.additionalItems = call.callResult.data;
          this.checkAddItemRole();
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      })
      .finally(() => {
        this.appEnv.isBusy = false;
      });
  }
  loadValueTypes() {
    apiService
      .getBaseItem(AppConstants.BaseItems.EmpAdditionType)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          let valueTypes = call.callResult.data;
          this.valueType = valueTypes.filter((s) => s.code != "EMPTY");
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      });
  }
  onClickEditItem(additionalId) {
    this.$emit("editAdditional", additionalId);
  }

  checkAddItemRole() {
    if (this.additionalItems.canEdit) {
      this.$emit("enableAddItem");
    }
  }
  get drawerParams() {
    return store.getters.drawerParams;
  }
  get appEnv() {
    return store.state.appEnv;
  }
}
